import React from 'react';
import './IntegrationInstalled.css';

const installedIntegrations = [
  { name: 'Slack', status: 'Active', lastUsed: '2 hours ago' },
  { name: 'Asana', status: 'Active', lastUsed: '1 hour ago' },
  { name: 'Zoom', status: 'Inactive', lastUsed: '3 days ago' },
  { name: 'Box', status: 'Active', lastUsed: '30 minutes ago' },
  { name: 'GitHub', status: 'Active', lastUsed: '5 minutes ago' },
  { name: 'Jira', status: 'Active', lastUsed: '1 day ago' },
  { name: 'Trello', status: 'Active', lastUsed: '2 days ago' },
  { name: 'Dropbox', status: 'Inactive', lastUsed: '1 week ago' },
  { name: 'Notion', status: 'Active', lastUsed: '4 hours ago' },
  { name: 'Figma', status: 'Active', lastUsed: '6 hours ago' },
  { name: 'Miro', status: 'Active', lastUsed: '1 day ago' },
  { name: 'Linear', status: 'Active', lastUsed: '3 hours ago' },
  { name: 'Monday.com', status: 'Active', lastUsed: '2 days ago' },
  { name: 'ClickUp', status: 'Inactive', lastUsed: '1 week ago' },
  { name: 'Airtable', status: 'Active', lastUsed: '1 hour ago' },
  { name: 'Typeform', status: 'Active', lastUsed: '5 hours ago' },
  { name: 'Zapier', status: 'Active', lastUsed: '30 minutes ago' },
  { name: 'Integromat', status: 'Active', lastUsed: '2 hours ago' },
];

const IntegrationInstalled = () => {

  return (
    <div className="integration-installed">
      <div className="integrations-grid">
        {installedIntegrations.map((integration, idx) => (
          <div key={idx} className="integration-card">
            <div className="integration-icon">📦</div>
            <div className="integration-name">{integration.name}</div>
            <div className="integration-type">BetterCloud UI Built</div>
            <div className="integration-status">{integration.status}</div>
            <div className="integration-last-used">Last used: {integration.lastUsed}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export { installedIntegrations };
export default IntegrationInstalled; 